import { Api } from 'utils';

class SpecialityService {

	static admin = {
		get: async (params?: any) => Api.createResponse('admin/specialities',params),
		create: async (params?: any) => Api.createResponse('admin/specialities/create',params),
		edit: async (params?: any) => Api.createResponse('admin/specialities/edit',params),
		delete: async (params?: any) => Api.createResponse('admin/specialities/delete',params),
	}

}

export default SpecialityService;